import $ from "jquery"

export function setupReferrerCookie() {
    $(document).ready(() => {
        let referrer = document.referrer;
        if (referrer) {
          const referrerHostname = referrer.split("/")[2] 
          if (location.hostname != referrerHostname) {
            document.cookie = "mp_referrer=" + referrer;
          }
          const urlParams = new URLSearchParams(window.location.search);
          const utm_source = urlParams.get('utm_source');
          const utm_medium = urlParams.get('utm_medium');
          const utm_campaign = urlParams.get('utm_campaign');
          if (utm_source) {
            document.cookie = "utm_source=" + utm_source;
          }
          if (utm_medium) {
            document.cookie = "utm_medium=" + utm_medium;
          }
          if (utm_campaign) {
            document.cookie = "utm_campaign=" + utm_campaign;
          }
        }
    })
}
